import React, { useEffect, useState } from "react";
import "./styles/ProgressSlider.css";

const ProgressSlider: React.FC<{ score: number; label: string }> = (props) => {
  // Handle slider change
  return (
    <div
      style={{
        padding: "10px",
        border: "1px solid var(--ion-color-medium)",
        borderRadius: "10px",
        background: "var(--ion-color-light)",
        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            fontSize: "1.7rem",
            padding: "5px",
            background: "var(--ion-color-dark)",
            border: "2px solid var(--ion-color-medium)",
            boxShadow: "0 3px 10px rgba(0, 0, 0, 0.1)",
            color: "var(--ion-color-light)",
            height: "3.4rem",
            width: "3.4rem",
            borderRadius: "50%",
            flexShrink: 0,
            marginRight: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="slider-smooth-number"
        >
          <b>{props.score}</b>
        </div>
        <div style={{ flexGrow: "1" }}>
          <div
            style={{
              paddingBottom: "5px",
              fontSize: ".8rem",
              fontWeight: "bold",
              paddingLeft: "3px",
            }}
          >
            {props.label}
          </div>
          <div className="slider-container">
            {/* Slider background */}
            <div className="slider-bar">
              <div
                className="slider-colored"
                style={{
                  width: `${100 - props.score}%`,
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressSlider;
